export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2024-08-29T04:43:11.765Z",
    "Language": "pl-PL",
    "Messages": {
        "3": "",
        "5": "",
        "10": "",
        "-": "",
        "...nie znalazłeś bloku? Dodaj nowy.": "",
        "${props.title}": "",
        "${statusIndex === 0 ? 'Powrót' : 'Powrót do edycji artykułu'}": "",
        "Aby nastąpiła automatyczna akceptacja regulaminu, wybrana wersja musi mieć status „Do akceptacji”.": "",
        "Adres": "",
        "Adres docelowy": "",
        "Adres domenowy": "",
        "Adres domeny": "",
        "Adres kanoniczny": "",
        "Adres strony": "",
        "Adres url": "",
        "Adres URL": "",
        "Adres url do pliku wideo": "",
        "Adres URL profilu autora.": "",
        "Adres źródłowy": "",
        "Akceptacja komentarzy": "",
        "Akceptuj": "",
        "Aktualności": "",
        "Aktualności ze strony": "",
        "Aktywacja kont po rejestracji": "",
        "Aktywne": "",
        "Aktywne do": "",
        "Aktywne od": "",
        "Aktywne teraz": "",
        "Aktywny": "",
        "Aktywuj przerwę techniczną w witrynie": "",
        "Alfabetycznie": "",
        "Ankieta": "",
        "Ankieta wyświetli się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Ankieta\" z narzędzi edytora": "",
        "Ankiety": "",
        "Anulowane": "",
        "Anuluj": "",
        "Anuluj edycję": "",
        "AQL": "",
        "Aranżacja alternatywna": "",
        "Aranżacja domyślna": "",
        "Aranżacja główna": "",
        "Aranżacja została dodana.": "",
        "Aranżacja została skopiowana.": "",
        "Aranżacja została usunięta.": "",
        "Aranżacja została zaktualizowana.": "",
        "Aranżacje": "",
        "Archiwum": "",
        "Artykuł": "",
        "Artykuł otwarty": "",
        "Artykuł premium": "",
        "Artykuł sponsorowany": "",
        "Artykuły": "",
        "Artykuły oznaczone jako \"Śródtekstowe\" wyświetlą się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Powiązane artykuły\" z narzędzi edytora": "",
        "Artykuły ze statusem PRIORYTET": "",
        "Asystenta AI": "",
        "Automat paczkowy": "",
        "Automatyczna akceptacja": "",
        "Automatyczna akceptacja komentarzy zalogowanych użytkowników": "",
        "Automatyczna akceptacja wszystkich komentarzy": "",
        "Automatyczna publikacja galerii": "",
        "Automatyczny": "",
        "Autor": "",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "",
        "Autor został dodany.": "",
        "Autor został usunięty.": "",
        "Autor został zaktualizowany.": "",
        "Autorzy": "",
        "Autorzy artykułu": "",
        "Autorzy spoza bazy użytkowników": "",
        "Baner został dodany.": "",
        "Baner został zaktualizowany.": "",
        "Banery": "",
        "Banner został usunięty.": "",
        "Barwa tekstu": "",
        "Barwa tła": "",
        "Baza dokumentów": "",
        "Bez \"http(s)://\" i \"/\" na końcu.": "",
        "Bezpieczeństwo": "",
        "Bezpieczny adres URL": "",
        "Blik": "",
        "Blok aktywny": "",
        "Blok jest wyłączony dla tej witryny": "",
        "Blok służy do wczytania ustawień wiadomości email według wybranej witryny i wersji językowej.": "",
        "Blok unikalny może zostać użyty tylko raz": "",
        "Blok został skopiowany do wskazanej witryny.": "",
        "Blok został usunięty.": "",
        "Bloki": "",
        "Błąd płatności": "",
        "Brak": "",
        "Brak artykułów": "",
        "Brak autorów": "",
        "Brak czołówki": "",
        "Brak danych": "",
        "Brak dodanych plików": "",
        "Brak etykiety": "",
        "Brak kategorii": "",
        "Brak kategorii nadrzędnej": "",
        "Brak listy regulaminów": "",
        "Brak modułu": "",
        "Brak odpowiedzi dla ankiety": "",
        "Brak plików do dodania": "",
        "Brak potwierdzenia": "",
        "Brak powiązań": "",
        "Brak stron": "",
        "Brak strony nadrzędnej": "",
        "Brak wybranych autorów": "",
        "Browse files": "",
        "Browse links": "",
        "Cena": "",
        "Cena brutto": "",
        "Cena została wyłączona z historii.": "",
        "Chronologia zdarzeń": "",
        "CMS": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Czas na slajd": "",
        "Czas na stronie": "",
        "Czas po jakim zamówienie wygaśnie": "",
        "Czas po jakim zamówienie zostanie anulowane": "",
        "Czas został zaktualizowany.": "",
        "Czas życia cacheu w sekundach": "",
        "Częstotliwość odświeżania": "",
        "Czołówka": "",
        "Czołówka została dodana.": "",
        "Czołówka została usunięta.": "",
        "Czołówka została zaktualizowana.": "",
        "Czwartek": "",
        "Czy chcesz ją przywrócić?": "",
        "Czytać mogą tylko zalogowani użytkownicy": "",
        "Dalsza część artykułu przeznaczona jest dla osób z subskrypcją premium": "",
        "Dane autoryzacyjne Google Analytics": "",
        "Dane autoryzacyjne powinny być przekazane w formacie JSON, który można uzyskać z pliku autoryzacyjnego utworzonego z klucza dostępowego na platformie Google Cloud": "",
        "Dane do faktury": "",
        "Dane klienta": "",
        "Data": "",
        "Data akceptacji": "",
        "Data automatycznej akceptacji": "",
        "Data dezaktywacji": "",
        "Data do": "",
        "Data dodania": "",
        "Data i godzina": "",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "",
        "Data modyfikacji": "",
        "Data modyfikacji:": "",
        "Data od": "",
        "Data odrzucenia": "",
        "Data opłacenia": "",
        "Data ostatniego użycia": "",
        "Data publikacji": "",
        "Data publikacji:": "",
        "Data rejestracji": "",
        "Data rezygnacji": "",
        "Data rozpoczęcia": "",
        "Data subskrypcji": "",
        "Data wprowadzenia": "",
        "Data wydania": "",
        "Data wygaśnięcia": "",
        "Data zakończenia": "",
        "Data zakończenia publikacji nie może być wcześniejsza, niż jej rozpoczęcie": "",
        "Data zapisania się": "",
        "Data zgłoszenia": "",
        "Daty publikacji": "",
        "Daty publikacji zostały zaktualizowane.": "",
        "Definicja szablonu": "",
        "Dla procesu zakupowego": "",
        "Długość": "",
        "Dni": "",
        "Do odebrania w punkcie": "",
        "Do poziomu": "",
        "Docelowa strona": "",
        "Dodaj": "",
        "Dodaj aranżację": "",
        "Dodaj autora": "",
        "Dodaj baner": "",
        "Dodaj czołówkę": "",
        "Dodaj do zestawu": "",
        "Dodaj dokument": "",
        "Dodaj etykietę": "",
        "Dodaj galerię": "",
        "Dodaj gazetkę": "",
        "Dodaj grupę": "",
        "Dodaj katalog": "",
        "Dodaj kategorie": "",
        "Dodaj kategorię": "",
        "Dodaj kolejne słowo": "",
        "Dodaj kolejny element": "",
        "Dodaj kolejny powód": "",
        "Dodaj link": "",
        "Dodaj nowa kategorię": "",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy tag": "",
        "Dodaj odpowiedź": "",
        "Dodaj opinię": "",
        "Dodaj plik": "",
        "Dodaj przekierowanie": "",
        "Dodaj pytanie": "",
        "Dodaj rotator": "",
        "Dodaj shortcode": "",
        "Dodaj ShortCode": "",
        "Dodaj slajd": "",
        "Dodaj slajder": "",
        "Dodaj stronę": "",
        "Dodaj szablon": "",
        "Dodaj wideo": "",
        "Dodaj witrynę": "",
        "Dodaj wpis": "",
        "Dodaj wzór": "",
        "Dodaj zestaw": "",
        "Dodane pliki z sortowaniem": "",
        "Dodane przez": "",
        "Dodane przez moje zespoły": "",
        "Dodane przeze mnie": "",
        "Dodanie aktualności": "",
        "Dodanie ankiety": "",
        "Dodanie aranżacji": "",
        "Dodanie artykułu": "",
        "Dodanie autora": "",
        "Dodanie baneru": "",
        "Dodanie czołówki": "",
        "Dodanie dokumentu": "",
        "Dodanie etykiety": "",
        "Dodanie galerii": "",
        "Dodanie gazetki": "",
        "Dodanie grupy": "",
        "Dodanie kategorii": "",
        "Dodanie linku": "",
        "Dodanie linku wewnętrznego": "",
        "Dodanie pakietu": "",
        "Dodanie poradnika": "",
        "Dodanie regulaminu": "",
        "Dodanie rotatora": "",
        "Dodanie slajdera": "",
        "Dodanie strony": "",
        "Dodanie szablonu": "",
        "Dodanie top tematu": "",
        "Dodanie wideo": "",
        "Dodanie witryny": "",
        "Dodanie wzoru": "",
        "Dodanie zestawu regulaminów": "",
        "Dodano za dużo stron (maksymalnie %0).": "",
        "Dodatkowe parametry w adresie URL": "",
        "Dokument": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dokument nie ma ustawionej daty publikacji.": "",
        "Dokument został dodany.": "",
        "Dokument został usunięty.": "",
        "Dokument został wysłany do publikacji.": "",
        "Dokument został zaktualizowany.": "",
        "Dokumenty": "",
        "Dołącz stronę do pliku sitemap.xml": "",
        "Domyślna": "",
        "Domyślna stopka": "",
        "Domyślna witryna": "",
        "Domyślne logo": "",
        "Domyślne ustawienie dla witryny": "",
        "Domyślny": "",
        "Domyślny tytuł aktywnej strony": "",
        "Dostarczone": "",
        "Dostawa": "",
        "Dostępna jest zapisana wersja robocza dokumentu.": "",
        "Dostępne bloki": "",
        "Dostępne dla": "",
        "Dostępne języki": "",
        "Dostępne moduły": "",
        "Dostępne wersje językowe.": "",
        "Dostępny w sekcjach": "",
        "Drugi klucz - md5": "",
        "Drugie powiadomienie": "",
        "Duplikuj": "",
        "Duplikuj aranżację": "",
        "Dzień tygodnia": "",
        "E-mail": "",
        "Edycja": "",
        "Edycja aktualności": "",
        "Edycja ankiety": "",
        "Edycja aranżacji": "",
        "Edycja artykułu": "",
        "Edycja autora": "",
        "Edycja baneru": "",
        "Edycja czołówki": "",
        "Edycja dokumentu": "",
        "Edycja etykiety": "",
        "Edycja galerii": "",
        "Edycja gazetki": "",
        "Edycja grupy": "",
        "Edycja kategorii": "",
        "Edycja komentarza": "",
        "Edycja linku": "",
        "Edycja linku wewnętrznego": "",
        "Edycja pakietu": "",
        "Edycja poradnika": "",
        "Edycja regulaminu": "",
        "Edycja rotatora": "",
        "Edycja slajdera": "",
        "Edycja strony": "",
        "Edycja szablonu": "",
        "Edycja top tematu": "",
        "Edycja ustawień": "",
        "Edycja wideo": "",
        "Edycja witryny": "",
        "Edycja wzoru": "",
        "Edycja zestawu regulaminów": "",
        "Edytuj": "",
        "Edytuj aranżację": "",
        "Edytuj aranżację alternatywną": "",
        "Edytuj blok": "",
        "Edytuj katalog": "",
        "Edytuj kategorię": "",
        "Edytuj komentarz": "",
        "Edytuj obszar": "",
        "Edytuj rotator": "",
        "Edytuj shortcode": "",
        "Edytuj slajder": "",
        "Edytuj stronę": "",
        "Edytuj tag": "",
        "Edytuj wpis": "",
        "Brak powiązanych wpisów dla tego bloku.": "",
        "Nie udało się pobrać powiązanych wpisów dla tego bloku.": "",
        "Ładowanie elementów...": "",
        "Ładowanie podglądu...": "",
        "Dodaj blok do sekcji": "",
        "Sekcja docelowa": "",
        "Brak dostępnych typów bloków.": "",
        "Jesteś w drugim dialogu: edycja wpisu.": "",
        "Pod spodem nadal masz otwarty podgląd aranżacji.": "",
        "Możesz bezpiecznie zamknąć ten dialog, aby wrócić do podglądu.": "",
        "Blok źródłowy": "",
        "Edytuj zestaw": "",
        "Email": "",
        "Email użytkownika": "",
        "Etykieta": "",
        "Etykieta została dodana.": "",
        "Etykieta została usunięta.": "",
        "Etykieta została zaktualizowana.": "",
        "Etykiety": "",
        "Export": "",
        "Facebook Admins": "",
        "Facebook Application ID": "",
        "FavIcona": "",
        "Film": "",
        "Film z YouTube": "",
        "Filtry": "",
        "Firma": "",
        "Folder został usunięty.": "",
        "Forma płatności": "",
        "Format pliku": "",
        "Formularz": "",
        "Formularz kontaktowy": "",
        "Formularz nie istnieje.": "",
        "Fraza": "",
        "Galeria": "",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "",
        "Galeria nie ma ustawionej daty publikacji.": "",
        "Galeria zdjęć": "",
        "Galeria zdjęć premium": "",
        "Galeria została dodana.": "",
        "Galeria została usunięta.": "",
        "Galeria została zaktualizowana.": "",
        "Gazetka": "",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "",
        "Gazetka nie ma ustawionej daty publikacji.": "",
        "Gazetka została dodana.": "",
        "Gazetka została usunięta.": "",
        "Gazetka została zaktualizowana.": "",
        "Generowanie stron gazetek...": "",
        "Generuj nowe sitemapy": "",
        "Generuj strony gazetki": "",
        "Generuj wszystkie metadane": "",
        "Godzina": "",
        "Google Maps": "",
        "Grupa": "",
        "Grupa banerów została dodana.": "",
        "Grupa banerów została usunięta.": "",
        "Grupa banerów została zaktualizowana.": "",
        "Grupy": "",
        "Historia cen": "",
        "Historia wyszukiwania": "",
        "i posiadających wymagane uprawnienia": "",
        "Id": "",
        "ID": "",
        "Id punktu płatności - posId": "",
        "ID wątku": "",
        "Identyfikator usługi Google Analytics": "",
        "Ikona": "",
        "Ikona wyświetlana jest w postaci kwadratu.": "",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności": "",
        "Ile razy system ponawia płatność": "",
        "Ilość artykułów w kategorii": "",
        "Ilość dni przed": "",
        "Ilość dostępnych bloków": "",
        "Ilość kolumn podkategorii": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość publikacji: %0": "",
        "Ilość wybranych stron: %0": "",
        "Ilość wyświetlanych aktualności": "",
        "Ilość wyświetlanych artykułów": "",
        "Ilość wyświetlanych tagów": "",
        "Ilość zaakceptowanych regulaminów: ": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Imię i nazwisko/nazwa autora": "",
        "Import": "",
        "Indeksowanie strony": "",
        "Informacja o ciasteczkach": "",
        "Informacje o zamówieniu": "",
        "Inspekcja": "",
        "Integracje": "",
        "Interakcja użytkownika (Komenatrze, Like)": "",
        "ISBN": "",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "",
        "Jeśli pole jest puste to wstawiana automatycznie.": "",
        "Język": "",
        "Język domyślny": "",
        "Karta": "",
        "Katalog": "",
        "Katalog linków": "",
        "Katalog został utworzony.": "",
        "Kategoria": "",
        "Kategoria linku": "",
        "Kategoria nadrzędna": "",
        "Kategoria subskrypcji": "",
        "Kategoria subskrypcji została dodana.": "",
        "Kategoria subskrypcji została usunięta.": "",
        "Kategoria subskrypcji została zaktualizowana.": "",
        "Kategoria urządzenia": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Kategorie linków": "",
        "Kategorie subskrypcji": "",
        "Kategorię": "",
        "Kategorię można opublikować tylko na jednej stronie.": "",
        "Kategorię subskrypcji": "",
        "Klienci": "",
        "Kobieta": "",
        "Kod bannera (tutaj wklej kod HTML i JS)": "",
        "Kod Bing Webmaster": "",
        "Kod Google Webmaster": "",
        "Kod GTM": "",
        "Kod HTML": "",
        "Kod pocztowy": "",
        "Kolejne pozycje z lewej strony": "",
        "Kolejne pozycje z prawej strony": "",
        "Kolor tekstu": "",
        "Kolor tła": "",
        "Komentarz": "",
        "Komentarz %0": "",
        "Komentarz do wyłączenia ceny": "",
        "Komentarze": "",
        "Komunikat mailowy": "",
        "Konfiguracja": "",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja asystenta ai": "",
        "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja bloku": "",
        "Konfiguracja bloku została zapisana.": "",
        "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja shortcode": "",
        "Konfiguruj stronę": "",
        "Konto publiczne": "",
        "Kontynent": "",
        "kopia": "",
        "Kopiuj": "",
        "Kopiuj do innej witryny": "",
        "Kopiuj do witryny": "",
        "Koszyk": "",
        "Kraj": "",
        "Krótki opis": "",
        "Krótki tytuł": "",
        "Książka": "",
        "Kurier": "",
        "Layout": "",
        "Liczba": "",
        "Liczba ankiet": "",
        "Liczba artykułów": "",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
        "Liczba wyników": "",
        "Liczba wyników na stronie": "",
        "Liczba wyświetlanych najnowszych elementów": "",
        "Liczba wyświetlanych slajdów": "",
        "Liczba wyświetleń": "",
        "Liczba zamówień": "",
        "Liczba zgłoszeń:": "",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "",
        "Limit zgłoszeń": "",
        "Limit znaków dla niezalogowanych": "",
        "Limit znaków dla zalogowanych": "",
        "Limity": "",
        "Linia ciągła": "",
        "Linia falująca": "",
        "Linia kreskowana": "",
        "Linia kropkowana": "",
        "Link": "",
        "Link do strony": "",
        "Link do wybranej strony serwisu": "",
        "Link do zewnętrznej strony": "",
        "Link wewnętrzny został dodany.": "",
        "Link wewnętrzny został usunięty.": "",
        "Link wewnętrzny został zaktualizowany.": "",
        "Link wygasł": "",
        "Link z serwisu": "",
        "Link został dodany.": "",
        "Link został usunięty.": "",
        "Link został zaktualizowany.": "",
        "Linki wewnętrzne": "",
        "Linki wewnętrzne zostały pomyślnie połączone.": "",
        "Lista": "",
        "Lista artykułów": "",
        "Lista banerów": "",
        "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "",
        "Lista jest pusta": "",
        "Lista komentarzy": "",
        "Lista linków": "",
        "Lista publikacji": "",
        "Lista regulaminów": "",
        "Logo": "",
        "Ładowanie zgłoszeń...": "",
        "Maksymalna ilość stron": "",
        "Maksymalna szerokość strony to 1410": "",
        "Maksymalna wysokość strony to 1080": "",
        "Marketing": "",
        "Metadane": "",
        "Metryka": "",
        "Mężczyzna": "",
        "Miasto": "",
        "Miesiące": "",
        "Miniatura zdjęcia": "",
        "Minimalna szerokość strony to 370": "",
        "Minimalna wysokość strony to 500": "",
        "Moduł": "",
        "Moduł dynamiczny": "",
        "Moduł konfigurowalny": "",
        "Moduły": "",
        "Moduły wyszukiwarki": "",
        "Monitoring": "",
        "Multimedia": "",
        "Multimedia premium": "",
        "Multimedia przypisane do artykułu": "",
        "Naciśnij enter aby usunąć": "",
        "Naciśnij enter aby wybrać": "",
        "Najniższa cena brutto z 30 dni przed obniżką": "",
        "Najniższy": "",
        "Najpierw dodaj stronę do gazetki.": "",
        "Najpierw zapisz wprowadzone zmiany": "",
        "Najpopularniejsze strony": "",
        "Najwięcej czasu spędzone na stronach": "",
        "Najwyższy": "",
        "Najwyższy poziom": "",
        "Narzędzia": "",
        "Nazwa": "",
        "Nazwa adresu": "",
        "Nazwa aktywnej strony": "",
        "Nazwa aranżacji": "",
        "Nazwa bloku": "",
        "Nazwa cechy": "",
        "Nazwa certyfikatu": "",
        "Nazwa czołówki": "",
        "Nazwa etapu": "",
        "Nazwa etykiety": "",
        "Nazwa grupy": "",
        "Nazwa kategorii": "",
        "Nazwa Kategorii": "",
        "Nazwa linku": "",
        "Nazwa pakietu": "",
        "Nazwa pliku": "",
        "Nazwa płyty": "",
        "Nazwa rotatora": "",
        "Nazwa sekcji": "",
        "Nazwa shortcode": "",
        "Nazwa slajdera": "",
        "Nazwa slajdu": "",
        "Nazwa strony": "",
        "Nazwa szablonu": "",
        "Nazwa użytkownika": "",
        "Nazwa w panelu": "",
        "Nazwa wewnętrzna": "",
        "Nazwa witryny": "",
        "Nazwa wyświetlana": "",
        "Nazwa wyświetlana:": "",
        "Nazwa zduplikowanej aranżacji": "",
        "Nazwa zestawu": "",
        "Nazwa:": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie ma jeszcze żadnych rekordów": "",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "",
        "Nie pomocna": "",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "",
        "Nie udało się pobrać kategorii": "",
        "Nie udało się pobrać listy aranżacji": "",
        "Nie udało się pobrać listy bloków": "",
        "Nie udało się pobrać listy etykiet": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy modułów": "",
        "Nie udało się pobrać listy modułów wyszukiwarki": "",
        "Nie udało się pobrać listy regulaminów": "",
        "Nie udało się pobrać listy stron": "",
        "Nie udało się pobrać listy szablonów": "",
        "Nie udało się skopiować aranżacji.": "",
        "Nie udało się skopiować bloku.": "",
        "Nie udało się ustawić aranżacji domyślnej": "",
        "Nie udało się załadować ankiet.": "",
        "Nie udało się załadować widgetu Google Analytics.": "",
        "Nie udało się załadować widgetu ostatnich użytkowników.": "",
        "Nie wybrano authora.": "",
        "Nie wybrano strony": "",
        "Nie wybrano żadnej kategorii": "",
        "Nie zdefiniowano żadnych sekcji.": "",
        "Nie znaleziono opublikowanej aranżacji.": "",
        "Nie znaleziono żadnych folderów.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nie związana": "",
        "Nieaktywne": "",
        "Nieaktywny": "",
        "Niedostępne bloki": "",
        "Niedozwolone słowa": "",
        "Niedziela": "",
        "Nieopłacone": "",
        "Niepotwierdzona": "",
        "Niestandardowy adres": "",
        "Niestandardowy adres strony": "",
        "Niestandardowy nagłówek": "",
        "Nieudana próba doręczenia": "",
        "Nieznany status": "",
        "Nigdy": "",
        "NIP": "",
        "Niski": "",
        "Niżej": "",
        "Nofollow": "",
        "Nowa aranżacja": "",
        "Nowa cena brutto": "",
        "Nowa cena do": "",
        "Nowa cena od": "",
        "Nowa kategoria": "",
        "Nowe sitemapy zostały wygenerowane.": "",
        "np. pl-PL": "",
        "Number": "",
        "Numer": "",
        "Numer aktywnej strony": "",
        "Numer domu/mieszkania": "",
        "Numer telefonu": "",
        "Obraz": "",
        "Obsługa cacheu dla witryny": "",
        "Oczekujący na akceptację": "",
        "Oczekuje na płatność": "",
        "Oczekuje na potwierdzenie": "",
        "Oczekuje na weryfikację": "",
        "Oczekuje na wysyłkę": "",
        "Oczekuje na zatwierdzenie": "",
        "Od poziomu": "",
        "Odebrane w punkcie": "",
        "Odnośnik URL": "",
        "Odpowiedzi": "",
        "Odpowiedź": "",
        "Odrzucone zgody": "",
        "Odrzucony po zgłoszeniach": "",
        "Odrzuć": "",
        "Odznacz wszystkie": "",
        "Ogólny": "",
        "Okładka": "",
        "Okładka do wideo premium": "",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "",
        "Open Graph": "",
        "Operator płatności": "",
        "Opinia": "",
        "Opis": "",
        "Opis przerwy technicznej": "",
        "Opis sekcji": "",
        "Opis witryny": "",
        "Opłacone": "",
        "Opublikowane": "",
        "Opublikowane języki": "",
        "Opublikowane wersje językowe.": "",
        "Opublikowany na stronach": "",
        "Opublikuj": "",
        "Opublikuj autora": "",
        "Ostatni miesiąc": "",
        "Ostatni rok": "",
        "Ostatni tydzień": "",
        "Ostatnia aktualizacja:": "",
        "Oś czasu": "",
        "Otwieraj w nowym oknie": "",
        "Otwórz stronę w nowym oknie": "",
        "Otwórz w nowej karcie": "",
        "Oznacz jako opłacone": "",
        "Pakiet": "",
        "Pakiet aktywny": "",
        "Pakiet autoodnawialny": "",
        "Pakiet został dodany.": "",
        "Pakiet został zaktualizowany.": "",
        "Pakiety": "",
        "Parametry email": "",
        "PayU": "",
        "Pełna strona": "",
        "Pełna treść:": "",
        "Pełny adres aktywnej strony": "",
        "Pełny adres wraz z \"http(s)://\".": "",
        "Piątek": "",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "",
        "Pierwsze powiadomienie": "",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "",
        "Piosenka": "",
        "Pisać mogą tylko zalogowani użytkownicy": "",
        "Plik": "",
        "Plik gazetki (PDF)": "",
        "Plik gazetki do pobrania (PDF)": "",
        "Plik graficzny": "",
        "Plik wideo": "",
        "Pliki": "",
        "Pliki do dodania": "",
        "Płatność": "",
        "Płeć": "",
        "Płyta z muzyką": "",
        "Po aktywacji wejście na dowolną stronę frontową przez użytkownika w obrębie witryny wyświetli informację o trwającej przerwie technicznej. Witryna podczas przerwy technicznej dla użytkowników z uprawnieniami administratora jest zawsze dostępna.": "",
        "Po zapisaniu artykułu w wybranej wersji językowej, nie będzie możliwości jej zmiany.": "",
        "Pobierz wyniki": "",
        "Poczta": "",
        "Podaj adres url...": "",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "",
        "Podążanie za linkami": "",
        "Podgląd": "",
        "Live design": "",
        "Podgląd artykułu": "",
        "Podgląd strony": "",
        "Podłącz linki wewnętrzne": "",
        "Podstawowe": "",
        "Podstawowe informacje": "",
        "Podwójna linia ciągła": "",
        "Pojedyncza publikacja": "",
        "Pojedynczy artykuł (strona opisowa)": "",
        "Pojedyńcza, prosta, ciągła linia": "",
        "Pokaż etykietę": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"Ilość dni przed\" jest wymagane.": "",
        "Pole \"Język\" jest wymagane.": "",
        "Pole \"Metryka\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Sortuj według\" jest wymagane.": "",
        "Pole \"Witryna\" jest wymagane.": "",
        "Pole \"Wymiar\" jest wymagane.": "",
        "Pole identyfikujące dokument": "",
        "Polubienia": "",
        "Pomoc": "",
        "Pomocna": "",
        "Poniedziałek": "",
        "Popularność": "",
        "Po otwarciu listy widzisz pierwsze wyniki. Wpisz początek wartości z pola identyfikującego, aby zawęzić listę.": "",
        "Potwierdzenie mailowe": "",
        "Potwierdzenie mailowe i akceptacja administratora": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie wysłania": "",
        "Potwierdzenie zatwierdzenia": "",
        "Potwierdzone": "",
        "Potwierdź": "",
        "Potwierdź akceptację": "",
        "Potwierdź przywrócenie wersji roboczej": "",
        "Potwierdź usunięcie": "",
        "Powiadomienia": "",
        "Powiązana galeria": "",
        "Powiązana kategoria": "",
        "Powiązane artykuły": "",
        "Powiązane galerie": "",
        "Powiązane kategorię": "",
        "Powiązane wideo": "",
        "Powiązany artykuł": "",
        "Powiązany autor": "",
        "Powód": "",
        "Powrót": "",
        "Powrót do edycji strony": "",
        "Pozostałe ustawienia": "",
        "Premiera": "",
        "Premium": "",
        "Premium otwarty": "",
        "Prezentacja": "",
        "Priorytet": "",
        "Procent": "",
        "Produkcyjne": "",
        "Profil użytkownika": "",
        "Protokół OAuth - clientId": "",
        "Protokół OAuth - clientSecret": "",
        "Przeciągnij do innej sekcji": "",
        "Przeciągnij do wybranej sekcji": "",
        "Przeglądarka": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Przekierowania": "",
        "Przekierowanie aktywne": "",
        "Przekierowanie zostało dodane.": "",
        "Przekierowanie zostało usunięte.": "",
        "Przekierowanie zostało zaktualizowane.": "",
        "Przenieś do sekcji": "",
        "Przenieś niżej": "",
        "Przenieś wyżej": "",
        "Przerwa techniczna": "",
        "Przesuń do góry": "",
        "Przesuń w dół": "",
        "Przywróć": "",
        "Przywróć zaznaczone": "",
        "Pseudonim": "",
        "Publiczne": "",
        "Publiczne ID:": "",
        "Publikacja": "",
        "Publikacja galerii przez użytkownika": "",
        "Publikacja priorytetowa": "",
        "Publikacja zarchiwizowana": "",
        "Publikacja została dodana.": "",
        "Publikacja została usunięta.": "",
        "Publikuj do": "",
        "Publikuj na stronie": "",
        "Publikuj na wybranej stronie": "",
        "Publikuj od": "",
        "Pytania i odpowiedzi": "",
        "Pytanie": "",
        "Recaptcha": "",
        "Redaktor został zaktualizowany.": "",
        "Region": "",
        "Regulamin wymagany": "",
        "Regulamin został dodany.": "",
        "Regulamin został zaktualizowany.": "",
        "Regulaminy": "",
        "Rejestracja konta": "",
        "Repozytorium plików": "",
        "Reżyseria": "",
        "Ręczna akceptacja wszystkich komentarzy": "",
        "Ręczny wybór zdjęć lub galerii": "",
        "Rodzaj adresu kanonicznego": "",
        "Rotator": "",
        "Rotator został dodany.": "",
        "Rotator został usunięty.": "",
        "Rotator został zaktualizowany.": "",
        "Rotatory opinii": "",
        "Rozwiń do": "",
        "RSS": "",
        "Scenariusz": "",
        "Sekcja": "",
        "Sekcja %0": "",
        "Sekcja komentarzy": "",
        "Sekcja modułu": "",
        "Sekcja pod artykułem": "",
        "Sekcja śródtekstowa": "",
        "Sekcje": "",
        "Separator elementów w tytule": "",
        "Serial telewizyjny": "",
        "Serie kresek lub fragmentów linii": "",
        "Serie kropek": "",
        "Shorcode nie istnieje. Usuń go z edytora.": "",
        "ShortCode został dodany.": "",
        "Shortcode został usunięty": "",
        "ShortCode został usunięty.": "",
        "ShortCode został zaktualizowany.": "",
        "Shortcodes": "",
        "Sitemapy": "",
        "Skopiowano": "",
        "Skrócony opis (label na froncie)": "",
        "Skrypt": "",
        "Skrypty zewnętrzne": "",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "",
        "Slajder": "",
        "Slajder został dodany.": "",
        "Slajder został usunięty.": "",
        "Slajder został zaktualizowany.": "",
        "Slajdery": "",
        "Słowa kluczowe": "",
        "Słowa oddzielone przecinkami.": "",
        "Słowo": "",
        "Sobota": "",
        "Sortowanie": "",
        "Sortowanie autorów": "",
        "Sortowanie kategorii": "",
        "Sortowanie pakietów": "",
        "Sortuj autorów": "",
        "Sortuj kategorie": "",
        "Sortuj pakiety": "",
        "Sortuj według": "",
        "Standardowa strona": "",
        "Stara cena brutto": "",
        "Status": "",
        "Status aranżacji został zmieniony.": "",
        "Status baneru został zmieniony.": "",
        "Status dokumentu został zmieniony.": "",
        "Status galerii został zmieniony.": "",
        "Status linku został zmieniony.": "",
        "Status płatności": "",
        "Status regulaminu został zmieniony.": "",
        "Status użytkownika": "",
        "Status wideo został zmieniony.": "",
        "Status zamówienia": "",
        "Status:": "",
        "Statyczny": "",
        "Strona": "",
        "Strona bez modułu": "",
        "Landing page z PageBuildera": "",
        "Strona do publikacji": "",
        "Strona docelowa dla 'Czytaj więcej'": "",
        "Strona docelowa dla 'Kontakt z adminem'": "",
        "Strona docelowa dla 'Pliki cookies'": "",
        "Strona docelowa dla 'Polityka prywatności'": "",
        "Strona dostępna dla wszystkich": "",
        "Strona dostępna tylko dla zalogowanych użytkowników": "",
        "Strona głowna": "",
        "Strona główna": "",
        "Strona logowania": "",
        "Strona nadrzędna": "",
        "Strona opublikowana": "",
        "Strona ukryta": "",
        "Strona z błędem 404": "",
        "Strona z modułu konto użytkownika": "",
        "Strona z modułu wyszukiwarki": "",
        "Strona została dodana.": "",
        "Strona została usunięta.": "",
        "Strona została zaktualizowana.": "",
        "Strona/kategoria nadrzędna": "",
        "Strony": "",
        "Strony gazetki": "",
        "Struktura serwisu": "",
        "Studio": "",
        "Subskrypcja": "",
        "Subskrypcja aktywna": "",
        "Subskrypcje": "",
        "Symbol": "",
        "Symbol autora": "",
        "Symbol linku": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol strony": "",
        "Synchronizuj": "",
        "System": "",
        "System operacyjny": "",
        "Szablon graficzny": "",
        "Szablon wiadomości": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony": "",
        "Szczegóły": "",
        "Szczegóły klienta": "",
        "Szczegóły wpisu": "",
        "Szczegóły zamówienia": "",
        "Szerokość": "",
        "Szerokość strony": "",
        "Szukaj": "",
        "Ścieżka aktywnej strony": "",
        "Ścieżka nawigacyjna": "",
        "Środa": "",
        "Środowisko": "",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "",
        "Tagi": "",
        "Tagi nie są widoczne w przypadku zaznaczenia opcji \"Wyświetlaj tylko treść\".": "",
        "Tak": "",
        "Target": "",
        "Tekstowy / HTML / JS": "",
        "Testowe": "",
        "Tokeny": "",
        "Top temat został dodany.": "",
        "Top temat został usunięty.": "",
        "Top temat został zaktualizowany.": "",
        "Top tematy": "",
        "Treść": "",
        "Treść artykułu": "",
        "Treść komentarza": "",
        "Treść nie może być pusta.": "",
        "Treść premium": "",
        "Tryb galerii": "",
        "Tryb wyświetlania": "",
        "Tydzień": "",
        "Tylko 404": "",
        "Tylko aktywne": "",
        "Tylko gdy odpowiedź serwera jest 404": "",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
        "Tylko priorytetowe": "",
        "Tylko treść": "",
        "Tylko zalogowani użytkownicy mogą zgłaszać komentarze": "",
        "Typ": "",
        "Typ aranżacji": "",
        "Typ autora": "",
        "Typ bannera": "",
        "Typ długości": "",
        "Typ długości pakietu": "",
        "Typ konta": "",
        "Typ obiektu:": "",
        "Typ pakietu": "",
        "Typ rankingu": "",
        "Typ strony": "",
        "Typ zestawu": "",
        "Tytuł": "",
        "Tytuł aktywnej witryny": "",
        "Tytuł elementu": "",
        "Tytuł okładki": "",
        "Tytuł pomocniczy": "",
        "Tytuł pomocniczy jest wyświetlany przed tytułem artykułu.": "",
        "Tytuł przerwy technicznej": "",
        "Tytuł strony": "",
        "Tytuł witryny": "",
        "Ukryj nazwę na front": "",
        "Ulica": "",
        "Uprawnienia": "",
        "Url": "",
        "URL": "",
        "Usatwienia komentarzy": "",
        "Ustaw kategorię": "",
        "Ustaw również dla wszystkich podstron": "",
        "Ustawienia": "",
        "Ustawienia domyślne": "",
        "Ustawienia dostępności": "",
        "Ustawienia konta": "",
        "Ustawienia płatności": "",
        "Ustawienia płatności zostały zaktualizowane.": "",
        "Ustawienia podstawowe": "",
        "Ustawienia redakcji": "",
        "Ustawienia rotatora": "",
        "Ustawienia sekcji \"%0\"": "",
        "Ustawienia slajdera": "",
        "Ustawienia strony": "",
        "Ustawienia witryny": "",
        "Ustawienia zostały zaktualizowane.": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń artykuł z listy": "",
        "Usuń autora": "",
        "Usuń blok z sekcji": "",
        "Usuń charmonogram": "",
        "Usuń dokument": "",
        "Usuń katalog": "",
        "Usuń kategorię": "",
        "Usuń odpowiedź": "",
        "Usuń opinię": "",
        "Usuń plik": "",
        "Usuń powiązanie": "",
        "Usuń powód": "",
        "Usuń publikację": "",
        "Usuń pytanie": "",
        "Usuń regulamin": "",
        "Usuń shortcode": "",
        "Usuń slajd": "",
        "Usuń słowo": "",
        "Usuń stronę": "",
        "Usuń tag": "",
        "Usuń wybrany element": "",
        "Usuń zaznaczone": "",
        "Usuń zestaw": "",
        "Uwaga! ": "",
        "Użytkownicy mogą zgłaszać komentarze": "",
        "Użytkownicy mogą zgłaszać komentarze do moderacji": "",
        "Użytkownik dokonał rejestracji samodzielnie.": "",
        "Użytkownik z bazy": "",
        "Użytkownik zalogowany": "",
        "Użytkownikcy z bazy": "",
        "W drodze": "",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "",
        "W przypadku zaznaczenia opcji \"Artykuł sponsorowany\" lub \"Opinia\", etykieta jest ustawiona automatycznie.": "",
        "W trakcie przygotowania": "",
        "W tym katalogu nie ma jeszcze żadnych stron.": "",
        "Walidacja": "",
        "Wartość długości": "",
        "Wartość tekstowa": "",
        "Ważne: Moduł ten obsługuje wyłącznie linki wewnętrzne, tj. odnoszące się do zasobów w ramach tej samej domeny i serwisu. Adresy należy podawać jako pełne ścieżki, na przykład: /stara-strona oraz /nowa-strona.": "",
        "Wersja językowa": "",
        "Wersja robocza została przywrócona.": "",
        "Wersje": "",
        "Wersje językowe": "",
        "Wewnętrzny": "",
        "Wiadomość została wysłana.": "",
        "Wideo": "",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "",
        "Wideo nie ma ustawionej daty publikacji.": "",
        "Wideo premium": "",
        "Wideo zostało dodane.": "",
        "Wideo zostało usunięte.": "",
        "Wideo zostało zaktualizowane.": "",
        "Widoczność": "",
        "Widok czołówki - zdjęcie z tytułem": "",
        "Więcej": "",
        "Witryna": "",
        "Witryna / Wersja językowa": "",
        "Witryna aktywna": "",
        "Witryna domyślna": "",
        "Witryna i język": "",
        "Witryna internetowa": "",
        "Witryna tylko dla zalogowanych użytkowników": "",
        "Witryna została dodana.": "",
        "Witryna została usunięta.": "",
        "Witryna została zaktualizowana.": "",
        "Witryny": "",
        "Właściwości": "",
        "Właściwość ``%0`` aktywnego wpisu": "",
        "Włącz ankietę": "",
        "Włącz formularz kontaktowy": "",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "",
        "Włącz social media": "",
        "Włącz system komentarzy": "",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "",
        "Włączenie obsługi cacheu": "",
        "Włączenie protokołu SSL dla tej witryny": "",
        "Włączone (Follow)": "",
        "Włączone (Index)": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisy zostały usunięte.": "",
        "Wpisy zostały zaakceptowane.": "",
        "Wprowadź link": "",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "",
        "Wstaw do edytora": "",
        "Wstęp": "",
        "Wstęp nie jest widoczny w przypadku zaznaczenia opcji \"Wyświetlaj tylko treść\".": "",
        "Wszystkie": "",
        "Wszystko": "",
        "Wtorek": "",
        "Wybierz": "",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "",
        "Wybierz ankietę": "",
        "Wybierz artykuł": "",
        "Wybierz autora": "",
        "Wybierz blok": "",
        "Wybierz czołówkę": "",
        "Wybierz datę": "",
        "Wybierz datę lub wprowadź wartość tekstową": "",
        "Wybierz daty publikacji": "",
        "Wybierz docelową aranżację": "",
        "Wybierz dokument": "",
        "Wybierz domyślną kategorię": "",
        "Wybierz etykietę": "",
        "Wybierz formularz": "",
        "Wybierz galerię": "",
        "Wybierz istniejącego użytkownika": "",
        "Wybierz język": "",
        "wybierz katalog": "",
        "Wybierz kategorie": "",
        "Wybierz kategorię": "",
        "Wybierz kategorię subskrypcji": "",
        "Wybierz link z serwisu": "",
        "Wybierz listę regulaminów": "",
        "Wybierz regulamin": "",
        "Wybierz sekcję": "",
        "Wybierz stronę": "",
        "Wybierz stronę do opublikowania": "",
        "Wybierz strony": "",
        "wybierz szablon": "",
        "Wybierz użytkownika": "",
        "Wybierz wideo": "",
        "Wybierz witrynę": "",
        "Wybierz z listy": "",
        "wybierz...": "",
        "Wybierz...": "",
        "Wybór listy stron": "",
        "Wybór strony": "",
        "Wybrana ikona powinna być kwadratem": "",
        "Wybrane artykuły": "",
        "Wybrane regulaminy:": "",
        "Wybrane strony": "",
        "Wybranie ankiety jest wymagane": "",
        "Wybranie katalogu jest wymagane": "",
        "Wybranie strony jest wymagane": "",
        "Wybraniue modułu jest wymagane": "",
        "Wybraniue sekcji jest wymagane": "",
        "Wybrano": "",
        "Wybrano etykietę \"Artykuł sponsorowany\".": "",
        "Wybrano etykietę \"Opinia\".": "",
        "Wybrany język": "",
        "Wybrany szablon": "",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "",
        "Wybróbuj możliwości AI": "",
        "Wygeneruj definicję szablonu w aplikacji frontendowej za pomocą asystenta komend `npm run edito` i wklej poniżej zawartość wygenerowanego pliku `theme.json` właściwego dla szablonu.": "",
        "Wygląd": "",
        "Wykonawca": "",
        "Wyłącz cenę": "",
        "Wyłącz cenę z historii": "",
        "Wyłącz system komentarzy": "",
        "Wyłącz udostępnianie": "",
        "Wyłączone (NoFollow)": "",
        "Wyłączone (NoIndex)": "",
        "Wyłączone komentarze": "",
        "Wyłączone przez": "",
        "Wyłączone udostępnianie": "",
        "Wymagaj ponownej akceptacji po zmianach": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie wersji językowej": "",
        "Wymagane jest wybranie witryny": "",
        "Wymagane jest wybranie zestawu regulaminów": "",
        "Wymiar": "",
        "Wyniki": "",
        "Wyniki_": "",
        "Wyrażone zgody": "",
        "Wysłane": "",
        "Wysoki": "",
        "Wysokość": "",
        "Wysokość strony": "",
        "Wystąpił błąd podczas próby exportu przekierowań.": "",
        "Wystąpił błąd podczas próby importu przekierowań.": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wyszukaj": "",
        "Wyszukaj albo dodaj nową kategorię": "",
        "Wyszukaj albo dodaj nowy tag": "",
        "Wyszukaj autora...": "",
        "Wyszukaj blok": "",
        "Wyszukaj czołówkę...": "",
        "Wyszukaj kategorię": "",
        "Wyszukaj regulamin...": "",
        "Wyszukaj tag": "",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów": "",
        "Wyślij powiadomienie - Ilość dni po zakończeniu subskrypcji:": "",
        "Wyślij powiadomienie - Ilość dni przed zakończeniem subskrypcji:": "",
        "Wyślij wiadomość": "",
        "Wyświetlaj artykuł na całą stronę": "",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "",
        "Wyświetlaj nazwę bloczka": "",
        "Wyświetlaj opinie z tłem": "",
        "Wyświetlaj tylko treść": "",
        "Wyświetlaj tytuł": "",
        "Wyświetlenia": "",
        "wyświetleń": "",
        "Wyżej": "",
        "Wzory": "",
        "YouTube (ID)": "",
        "Zaakceptowane wersje": "",
        "Zaakceptowany": "",
        "Zaawansowane polecenia": "",
        "zacznij pisać aby wyszukać ankietę...": "",
        "zacznij pisać aby wyszukać ankiety...": "",
        "zacznij pisać aby wyszukać artykuł...": "",
        "zacznij pisać aby wyszukać autora...": "",
        "zacznij pisać aby wyszukać dokument...": "",
        "zacznij pisać aby wyszukać galerię...": "",
        "zacznij pisać aby wyszukać grupę...": "",
        "zacznij pisać aby wyszukać kategorię...": "",
        "zacznij pisać aby wyszukać rotator...": "",
        "zacznij pisać aby wyszukać slajder...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "zacznij pisać aby wyszukać wideo...": "",
        "Zaimportowano listę przekierowań.": "",
        "Zakończone": "",
        "Zakres dat": "",
        "Zaktualizowano.": "",
        "Załączniki": "",
        "Załączniki premium": "",
        "Zamiany zostały zapisane.": "",
        "Zamknij": "",
        "Zamówienia": "",
        "Zamówienie": "",
        "Zamówienie zostało zaktualizowane.": "",
        "Zamówiony pakiet": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz zmiany": "",
        "Zaplanowane": "",
        "Zapytanie AI": "",
        "Zapytanie EQL": "",
        "Zapytanie użytkownika": "",
        "Zarządzanie": "",
        "Zarządzanie witrynami": "",
        "Zatwierdź": "",
        "Zatwierdź zaznaczone": "",
        "Zawiera sekcje": "",
        "Zawierające jeden z wybranych tagów": "",
        "Zawsze": "",
        "Zaznacz wszystkie": "",
        "Zaznaczone": "",
        "Zaznaczone (${checkedItems.value.length})": "",
        "Zdjęcia": "",
        "Zdjęcia premium": "",
        "Zdjęcie": "",
        "Zdjęcie autora": "",
        "Zdjęcie dla tabletów": "",
        "Zdjęcie dla urządzeń mobilnych": "",
        "Zdjęcie główne": "",
        "Zdjęcie główne nie jest widoczne w przypadku zaznaczenia opcji \"Wyświetlaj tylko treść\".": "",
        "Zdjęcie na okładce": "",
        "Zdjęcie użytkownika": "",
        "Zdjęcie w tle": "",
        "Zdjęcie/ikonka": "",
        "Zestaw": "",
        "Zestaw niestandardowy": "",
        "Zestaw został dodany.": "",
        "Zestaw został zaktualizowany.": "",
        "Zewnętrzne skrypty statystyk": "",
        "Zewnętrzne skrypty targetujące": "",
        "Zewnętrzny": "",
        "Zewnętrzny serwis": "",
        "Zgłaszanie komentarzy": "",
        "Zgłoszenia": "",
        "Zmiana formularza nie będzie możliwa po zapisaniu ShortCode": "",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "",
        "Zmiany w tym widoku bezpośrednio wpływają na funkcjonowanie aplikacji frontend. Przed edycją jakichkolwiek danych upewnij się, że są one przemyślane i uzasadnione. Niewłaściwa modyfikacja może skutkować nieprawidłowym działaniem aplikacji.": "",
        "Zmiany zostały zapisane.": "",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "",
        "Zmień daty publikacji": "",
        "Znajdź typ bloku...": "",
        "Zobacz przed opublikowaniem": "",
        "Zobacz wszystkich użytkowników": "",
        "Zobacz wszystkie artykuły": "",
        "Zobacz wszystkie komentarze": "",
        "Zobacz wszystkie wpisy": "",
        "Zrezygnowano z subskrypcji": "",
        "Zwrot do nadawcy": "",
        "Źródło URL": ""
    }
};
